import { render, staticRenderFns } from "./BannerPlanos.vue?vue&type=template&id=0d9e6158"
import script from "./BannerPlanos.vue?vue&type=script&lang=js"
export * from "./BannerPlanos.vue?vue&type=script&lang=js"
import style0 from "./BannerPlanos.vue?vue&type=style&index=0&id=0d9e6158&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports